import { ObstacleNameValues } from '../entities/obstacle/Obstacle';
import { PassengerIconValues, PassengerSpriteValues } from '../Passenger';
import { ThemeNameValues } from './../themes/theme';

export const LevelName = {
  Level1: 'level1',
  Level2: 'level2',
  Level3: 'level3',
  Level4: 'level4',
  Level5: 'level5',
  Level6: 'level6',
  Level7: 'level7',
  Level8: 'level8',
  Level9: 'level9'
} as const;
export type LevelNameKeys = keyof typeof LevelName;
export type LevelNameValues = typeof LevelName[LevelNameKeys];

export const LevelState = {
  Purchased: 'Purchased',
  Unlocked: 'Unlocked',
  Locked: 'Locked'
} as const;
export type LevelStateKeys = keyof typeof LevelState;
export type LevelStateValues = typeof LevelState[LevelStateKeys];

export interface Level {
  id: LevelNameValues;
  theme: ThemeNameValues;
  laneItemDetails: LaneItemDetails;
  trafficDetails: TrafficDetails;
  taxiDetails: TaxiDetails;
  passengerDetails: PassengerDetails;
}

export interface LevelPurchaseDetails {
  linkedLevel: LevelNameValues;
  price: number;
  nextLevel: LevelNameValues | undefined;
  nextLevelPrice: number | undefined;
}

export interface RoadDetails {
  laneCount: number;
  lanes: { [key: number]: LaneDetails };
  laneHeight: number;
  laneScale: number;
  laneVehicleScale: number;
  startPointX: number;
  startPointY: number;
  vehicleOffset: number;
  obstacleOffset: number;
  // endPointX: number;
  pavementY: number;
  pavementHeight: number;
}

export interface LaneDetails {
  laneY: number;
}

export interface LaneItemDetails {
  minLanesAtOnce: number;
  maxLanesAtOnce: number;
  /**
   * How much a position has to have changed by to start another spawn round.
   * Stops multiple rounds of spawning happening in the same location.
   * Effectively the min distance before the next set of potential items can
   * spawn. Spawns can be blank if there's nothing left to spawn.
   */
  antiRepeatSpawnDistance: number;
  minSpawnAheadDistance: number;
  maxSpawnAheadDistance: number;
  defaultMaxSpawned: number;
  defaultTimeBetweenSpawns: number;
  allowedObstacles: ObstacleNameValues[];
  obstacleConfiguration: Partial<Record<ObstacleNameValues, LaneItemConfig>>;
  boostConfiguration: LaneItemConfig;
}

export interface LaneItemConfig {
  maxSpawned: number;
  timeBetweenSpawns: number;
}

export interface TrafficDetails {
  maxVehicles: number;
  minTimeBetweenSpawns: number;
  maxTimeBetweenSpawns: number;
  minSpawnAheadDistance: number;
  maxSpawnAheadDistance: number;
  maxLanesAtOnce: number;
  minTimeBetweenSpeedChanges: number;
  maxTimeBetweenSpeedChanges: number;
}

export interface TaxiDetails {
  npcTaxis: number;
  taxis: { startLane: number; startIndentX: number }[];
}

export interface PassengerDetails {
  defaultPassengerPickupBonus: number;
  defaultPassengerDropOffBonus: number;
  defaultPassengerDistanceRate: number;
  passengers: PassengerJourney[];
}

export interface PassengerJourney {
  sprite: PassengerSpriteValues;
  icon: PassengerIconValues;
  pickupDistance: number;
  travelDistance: number;
  passengerPickupBonus?: number;
  passengerDropOffBonus?: number;
  passengerDistanceRate?: number;
}
